<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
>
  <span class="header-title">Jumpers</span>
</div>
<div class="form">
  <div class="section-container">
    <div class="title">
      <span>Transfer Jumper</span>
    </div>
    <div class="content">
      <div class="datum">
        <app-dropdown
          [choice]="selectedBase"
          label="Base"
          [options]="bases"
          key="displayValue"
          (selectedDropdownItem)="selectBase($event)"
        ></app-dropdown>
      </div>
      <div class="datum">
        <app-combobox
          [choice]="selectedJumper"
          label="Select Jumper"
          [options]="jumpers"
          key="name"
          (selectedComboboxItem)="selectJumper($event)"
        ></app-combobox>
        <span class="required-asterisk">*</span>
      </div>
    </div>
  </div>
  <div class="section-container submit-button-container">
    <app-button
      [disabled]="selectedJumper.name.length <= 0"
      [text]="buttonText"
      (clicked)="transferJumper($event)"
    ></app-button>
  </div>
</div>
